import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // eslint-disable-next-line react-hooks/exhaustive-deps
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
reportWebVitals();
